





































































import Vue from 'vue'
import { createComponent, onMounted, ref, Ref } from '@vue/composition-api'
import { Message, MessageBox } from 'element-ui'
import { TableFile, IFile } from '@oppo/slice-uploader/src/types'
import { SameFileType } from '@/service/public'
import { reqSameNameCheck } from '@/service/allUse'
import { getFileInfoByUuid, notifyUser } from '@/service/common'
import CountDown from '@/components/CountDown.vue'
import dayjs from 'dayjs'
export default createComponent({
    components: {
        CountDown,
    },
    setup(props, setupContext) {
        // const store = useStore();
        const sliceUpload = ref<Vue>(null)
        const uuid = setupContext.root.$route.query.id as string
        const dirName = ref<string>('')
        const dirId = ref<string>('')
        const hasFileUploaded = ref<boolean>(false)
        const useSpliceUploadFile = sliceUploader(dirId, uuid, hasFileUploaded)
        const checkFileUrl = `/common/upload/${uuid}`
        const sendFileUrl = `/common/upload/${uuid}`
        const saveFileUrl = `/common/saveUploadFile/${uuid}`
        const expirationTime = ref('0')
        const managers = ref<string>('')
        const reminder = ref<string>('')
        const { hasAlert, alertHandler } = infoHandle(uuid, hasFileUploaded)
        const canUpload = ref<boolean>(false)
        canUpload.value = !!uuid
        const selectFileClick = async () => {
            // if (isElectron()) {
            // eslint-disable-next-line no-constant-condition
            if (false) {
                console.log('上传请求客户端')
                // const dirId = dirInfo.value.file.id;
                // const shareIdentify = dirInfo.value.shareIdentify;
                // await desktopUploadHandler(dirId, shareIdentify);
            } else {
                if (!uuid) {
                    Message.error('分享链接异常，缺少参数')
                    return
                }
                if (!canUpload.value) {
                    Message.error('文件夹信息异常，暂不可上传')
                    return
                }
                ;(sliceUpload.value as any).selectFile()
            }
        }
        const fileDragover = e => {
            e.preventDefault()
        }
        const fileDrop = e => {
            e.preventDefault()
            if (!uuid) {
                Message.error('分享链接异常，缺少参数')
                return
            }
            if (!canUpload.value) {
                Message.error('文件夹信息异常，暂不可上传')
                return
            }
            if (!e.dataTransfer || !e.dataTransfer.files.length) {
                return
            }
            const files = e.dataTransfer.files
            // eslint-disable-next-line no-useless-escape
            const reg = /\.[^\.]+$/ //通过扩展名判断
            let excludeDir: any[] = []
            for (let file of files) {
                if (reg.test(file.name)) {
                    excludeDir.push(file)
                } else {
                    Message.error('不支持文件夹上传！')
                }
            }
            if (!excludeDir.length) {
                return
            }
            ;(sliceUpload.value as any).selectDrapFile(e.dataTransfer.files)
        }
        const { formatCheckFileHttpParam } = formatUploadParam(uuid)
        onMounted(async () => {
            hasAlert.value = false
            if (!uuid) {
                Message.error('上传链接异常，缺少参数')
                return
            }

            const res = await getFileInfoByUuid({ id: uuid })
            if (res && res.code === 0 && res.data) {
                dirName.value = res.data.dir && res.data.dir.name ? res.data.dir.name : ''
                const expireTime = res.data.expire || 0
                // 将时间秒处理成统一格式
                expirationTime.value = dayjs().add(expireTime,'second').format('YYYY-MM-DD HH:mm:ss')
                dirId.value = res.data.dir && res.data.dir.id ? res.data.dir.id : ''
                // 通知人
                if (res.data.notify) {
                    if (res.data.notify.users) {
                        const managerNames = res.data.notify.users.map(item => {
                            return !!item.value && item.value
                        })
                        if (managerNames.length) {
                            managers.value = managerNames.join(',')
                        }
                    }
                    if (res.data.notify.reminder) {
                        reminder.value = res.data.notify.reminder
                    }
                }
                if (expireTime <= 0) {
                    setupContext.root.$router.push(`/linkinvalid?name=${managers.value}`)
                }
            } else {
                const eMsg = res && res.desc ? res.desc : '查询文件夹信息失败'
                canUpload.value = false
                Message.error(eMsg)
                setupContext.root.$router.push('/nopermission')
            }
        })

        return {
            sliceUpload,
            selectFileClick,
            ...useSpliceUploadFile,
            checkFileUrl,
            sendFileUrl,
            saveFileUrl,
            expirationTime,
            dirName,
            dirId,
            formatCheckFileHttpParam,
            alertHandler,
            hasAlert,
            fileDragover,
            fileDrop,
            managers,
            reminder,
            canUpload,
        }
    },
})
function infoHandle(id: string, hasFileUploaded: Ref<boolean>) {
    const hasAlert = ref<boolean>()
    const alertHandler = async () => {
        if (!id) {
            Message.error('分享链接异常，缺少参数')
            return
        }
        if (!hasFileUploaded.value) {
            Message.error('尚未上传文件！')
            return
        }
        const res = await notifyUser(id)
        hasAlert.value = true
        if (!res || res.code !== 0) {
            console.log('通知失败！')
        }
    }
    return {
        hasAlert,
        alertHandler,
    }
}
function sliceUploader(dirId, uuid, hasFileUploaded: Ref<boolean>) {
    const checkFileHandler = res => {
        if (res.code === 0) {
            return true
        }
        return false
    }
    const checkSameFile = async (file: TableFile) => {
        let checkType: SameFileType
        let newName = ''
        try {
            let res
            // res = await request.get("/api/checkFile", { params: query });
            res = await reqSameNameCheck({
                name: file.name,
                dirId: dirId.value as string,
                fileType: 'file',
                uuid: uuid as string,
            })
            let sameNameObj
            if (!res || (res && res.code !== 0)) {
                Message.error('检查文件重名出错！')
                return { checkType: SameFileType.ERROR }
            }
            if (res.code === 0) {
                sameNameObj = res.data
            }
            if (sameNameObj) {
                checkType = sameNameObj.identifier === file.id ? SameFileType.SAME_MD5 : SameFileType.SAME_NAME
                newName = sameNameObj.rename
            } else {
                checkType = SameFileType.NOT_SAME
            }
        } catch (e) {
            Message.error('检查文件重名出错！')
            checkType = SameFileType.ERROR
        }

        return { checkType, newName }
    }
    const handleSameFile = async (fileName: string, param: { checkType: SameFileType; newName: string }) => {
        const { checkType, newName } = param
        return new Promise((resolve, reject) => {
            let saveFile = true
            if (checkType === SameFileType.ERROR) {
                saveFile = false
                resolve({ saveFile })
            } else if (checkType === SameFileType.SAME_NAME) {
                const newFileName = newName
                MessageBox.confirm(`系统将上传文件更名为${newFileName},是否继续执行该操作`, '当前路径存在相同文件名', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                    .then(() => {
                        resolve({
                            saveFile,
                            newFileName,
                        })
                    })
                    .catch(() => {
                        saveFile = false
                        resolve({
                            saveFile,
                            newFileName,
                        })
                    })
            } else {
                if (checkType === SameFileType.SAME_MD5) {
                    saveFile = false
                    hasFileUploaded.value = true
                    Message.success('文件已存在！')
                }
                resolve({ saveFile })
            }
        })
    }
    const shouldAddedFilesUpload = async (files: FileList) => {
        // const isContinue = await preTransferHandler(files, transferThreshold);
        const isContinue = true
        if (isContinue) {
            return files
        } else {
            return []
        }
    }
    const checkFileUploadedChunks = res => {
        let data = []
        if (res.data && res.data.length) {
            data = res.data.map(v => {
                // 后台索引是1开始的
                return v - 1
            })
        }
        if (res.code != 0) {
            Message.error(res.desc)
        }
        return data
    }
    const hasAlertSuccess = ref<boolean>(false)
    const onFileSuccess = (res, file: TableFile) => {
        // store.dispatch("publicStore/getTableData");
        if (hasAlertSuccess.value) {
            return
        }
        hasFileUploaded.value = true
        Message.success('上传成功！')
    }
    const onFileStateSuccess = (file: TableFile) => {
        // store.dispatch("publicStore/getTableData");
        hasFileUploaded.value = true
        hasAlertSuccess.value = true

        Message.success('上传成功！')
    }
    const onFileMd5Error = () => {
        Message.error('计算文件MD5值出错')
    }
    const onFileError = (res, file: TableFile) => {
        const msg = `${file.name} | ${res.desc || '文件上传失败[未知原因]'}`
        Message.error(msg)
    }
    const onFilecheckError = (err: any, file: IFile) => {
        const msg = `${file.name} | ${err.desc || '文件上传失败[未知原因]'}`
        Message.error(msg)
    }
    return {
        checkFileHandler,
        checkSameFile,
        handleSameFile,
        shouldAddedFilesUpload,
        checkFileUploadedChunks,
        onFileSuccess,
        onFileError,
        onFilecheckError,
        onFileMd5Error,
        onFileStateSuccess,
        hasAlertSuccess,
        hasFileUploaded,
    }
}
function formatUploadParam(uuid: string) {
    const formatCheckFileHttpParam = params => {
        const { identifier, filename, dirId } = params

        return { uuid, identifier, filename }
    }

    return {
        formatCheckFileHttpParam,
    }
}
